import React from 'react'
import { Formik, Form, Field } from 'formik'
import MultiselectCheckboxSubmenus from './fields/MultiselectCheckboxSubmenus'
import ButtonSubmitCancel from '../general/ButtonSubmitCancel'
import Translation from '../Translation/cont/Translation'


const FormProgramOverviewSubmenus = ({attributes, programOverviewSubmenus, cinemaAttributes, onUpdateProgramOverviewSubmenus}) => {
    if(_.isEmpty(attributes) || _.isEmpty(cinemaAttributes)) {
        return <span className="form-program-submenus selections-item-selections section-left"><Translation id="website_no_submenus_available"/> <a className="support-mail text-regular-color cursor-pointer" href="mailto:support@pmkino.com"><Translation id="website_no_submenus_available_Support"/></a></span>
    }
    return (
        <Formik
            initialValues={programOverviewSubmenus}
            onSubmit={(values, actions) => {
                onUpdateProgramOverviewSubmenus(values)
                actions.setSubmitting(false)
            }}
            onReset={(values, actions) => {
            }}>
            {({ values, errors, status, touched, isSubmitting, handleReset }) => (
                <Form className="form-program-submenus selections-item-selections section-left">
                    <div className="form-content">
                        <fieldset className="field-category field-genres">
                            <legend className="text-small-light"><Translation id="movie_edit_movie_genres"/></legend>

                            <div className="grid-container">
                                {!_.isEmpty(attributes.genres) && Object.keys(attributes.genres).map(attrId => (
                                    <div key={'field' + attrId} className="field-checkbox">
                                        <Field 
                                            key={attrId} 
                                            attrid={attrId}
                                            name="genres"
                                            component={MultiselectCheckboxSubmenus} 
                                            id={attributes.genres[attrId].name}
                                            value={attrId} 
                                        />
                                    </div>
                                ))}
                            </div>
                        </fieldset>

                        <fieldset className="field-category field-genres">
                            <legend className="text-small-light"><Translation id="movie_edit_tab_movie_series"/></legend>

                            <div className="grid-container">
                                {!_.isEmpty(cinemaAttributes.technical) && Object.keys(cinemaAttributes.technical).map(attrId => (
                                    <div key={'field' + attrId} className="field-checkbox">
                                        <Field 
                                            key={attrId} 
                                            attrid={attrId}
                                            name="technical"
                                            component={MultiselectCheckboxSubmenus} 
                                            id={cinemaAttributes.technical[attrId].name} 
                                            value={attrId}
                                        />
                                    </div>
                                ))}
                            </div>
                        </fieldset>
                    </div>

                    <ButtonSubmitCancel
                        transIdCancel="cancel_button"
                        transIdSubmit="save_submenus_button"
                        disabledCancel={isSubmitting}
                        disabledSubmit={isSubmitting}
                        onCancel={handleReset}
                    />
                </Form>
            )}
        </Formik>
    )

}

export default FormProgramOverviewSubmenus